/* unplugin-vue-components disabled */import script from "./YkAdaptiveBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./YkAdaptiveBox.vue?vue&type=script&lang=ts&setup=true"

import "./YkAdaptiveBox.vue?vue&type=style&index=0&id=b7001d58&lang=scss&scoped=true"

import exportComponent from "/Users/shenhao/workDocument/idea/IDEACode/YKWebCode/shaoguanFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7001d58"]])

export default __exports__